/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import PlatformResellerInterface from '../../interfaces/platform/PlatformResellerInterface';
import { useSelector } from 'react-redux';
import { useDiscountsHook, useDiscountSimpleSelectElements } from '../../modules/lib/hooks/useDiscountHook';
import { ProductActionField } from '../../modules/simcard/ProductReducer';
import GridItem from '../../components/Grid/GridItem';
import { SimpleSelect } from '../../components/Adescom/SimpleSelect';
import i18n from '../../core/i18n';
import ActivateFeatureButton from '../../components/Buttons/ActivateFeatureButton';

type VirtualComponentEditDiscountType = {
    platformReseller: PlatformResellerInterface;
    addCallback: (param: { value: number; name: string }) => void;
};

export const VirtualComponentEditDiscount: FunctionComponent<VirtualComponentEditDiscountType> = ({
    platformReseller,
    addCallback,
}): ReactElement => {
    const { discounts } = useSelector((state: { productReducers: ProductActionField }) => state.productReducers);
    const [discountToActivate, setDiscountToActivate] = useState(-1);
    const [discountNameToActivate, setDiscountNameToActivate] = useState('');

    useDiscountsHook(
        [
            { name: 'platformResellerId', value: platformReseller.id },
            { name: 'allowUseOnProduct', value: -1 },
            { name: 'discountAll', value: 1 },
            { name: 'active', value: false },
            { name: 'pagination', value: false },
        ],
        [{ value: 'asc', name: 'mainname' }]
    );

    const discountSimpleList = useDiscountSimpleSelectElements(discounts);

    const discountSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setDiscountToActivate(parseInt(event.target.value));
        for (let i = 0; i < discountSimpleList.length; i++) {
            if (discountSimpleList[i].value === parseInt(event.target.value)) {
                setDiscountNameToActivate(discountSimpleList[i].name);
                break;
            }
        }
    };

    const addPromotion = (): void => {
        if (discountToActivate === -1) {
            return;
        }
        addCallback({ value: discountToActivate, name: discountNameToActivate });
        setDiscountNameToActivate('');
        setDiscountToActivate(-1);
    };

    return (
        <GridContainer>
            <GridItem xs={8}>
                <SimpleSelect
                    label="prov:features.choose_discount"
                    required={false}
                    elements={discountSimpleList}
                    dispatchName={'no-name'}
                    fieldName="discountSelect"
                    callback={discountSelect}
                    selectedValue={discountToActivate}
                />
            </GridItem>
            <GridItem xs={4} style={{ textAlign: 'right', marginTop: '15px' }}>
                <ActivateFeatureButton
                    nonTableButton
                    callback={addPromotion}
                    callbackParam={{}}
                    tooltipTitle={i18n.t('prov:features.add_promotion')}
                    size="sm"
                />
            </GridItem>
        </GridContainer>
    );
};
